module.exports = __webpack_public_path__ + "media/images/ico-recording-7dfb98c5.svg";